import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AiOutlineHome, AiOutlineSearch, AiOutlineUser } from 'react-icons/ai';
import LanguageSelector from './LanguageSelector';
import BrandLogo from '../BrandLogo';
//import { getCurrentBrand } from '../../config/brands';

export const scrollToTop = (smooth = true) => {
    window.scrollTo({ 
        top: 0, 
        behavior: smooth ? 'smooth' : 'auto'
    });
};

const Header = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    
    const ClickHandler = () => {
        scrollToTop();
    };    
    const homeClickHandler = () => {
        // Force a full page reload to ensure initial state (like search box) is reset
        window.location.href = '/home'; 
    };
    
    // Previously used for brand-specific styling, keeping getCurrentBrand import for future use
    // const currentBrand = getCurrentBrand();

    // CSS-in-JS Styles
    const styles = {
        // ✅ เมนูจอใหญ่ (ลอยบนพื้นหลัง)
        headerContainer: {
            width: "100%",
            position: "absolute", // ✅ ให้อยู่บนสุดของจอ
            top: "0",
            left: "0",
            backgroundColor: "transparent", // ✅ ไม่มีพื้นหลัง
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "20px 40px", // ✅ เพิ่ม padding
            zIndex: 1000, // ✅ ให้ลอยอยู่ด้านบนสุด
        },
        logo: {
            maxWidth: "120px",
        },
        nav: {
            display: "flex",
            listStyle: "none",
            padding: 0,
            margin: 0,
        },
        navItem: {
            margin: "0 15px",
        },
        navLink: {
            textDecoration: "none",
            color: "#fff", // ✅ เปลี่ยนเป็นสีขาวให้อ่านง่าย
            fontSize: "16px",
        },
        // ✅ Language Selector มุมขวาสุดของเมนูจอใหญ่
        languageBarDesktop: {
            marginLeft: "auto",
        },
        // ✅ Language Selector มุมขวาบนของมือถือ
        languageBarMobile: {
            position: "fixed",
            top: "15px", // Adjusted to match the close button's vertical center
            right: "55px",
            zIndex: 9998,
            height: "30px",
            display: "flex",
            alignItems: "center"
        },
        // ✅ แถบเมนูด้านล่างของมือถือ
        bottomNav: {
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            backgroundColor: "#fff",
            boxShadow: "0 -4px 12px rgba(0, 0, 0, 0.2)", // ✅ เงาชัดขึ้น
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            padding: "8px 0", // ✅ เพิ่ม padding ให้ใหญ่ขึ้น
            borderRadius: "25px 25px 0 0",
            zIndex: 1000,
        },
        navButton: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textDecoration: "none",
            color: "#666",
            fontSize: "14px",
            fontWeight: "500",
        },
        activeButton: {
            color: "#007bff", // ✅ สีปุ่มเมื่อ Active (เช่น Home)
        },
        icon: {
            fontSize: "36px", // ✅ ไอคอนใหญ่ขึ้น
        },
    };

    return (
        <>
            {/* ✅ Language Selector มุมขวาบนของมือถือ */}
            <div style={styles.languageBarMobile} className="d-lg-none">
                <LanguageSelector />
            </div>

            {/* ✅ Header ปกติสำหรับจอใหญ่ (ลอยบนพื้นหลัง) */}
            <div style={styles.headerContainer} className="d-none d-lg-flex">
                <Link onClick={homeClickHandler} to="/home">
                    <BrandLogo style={styles.logo} />
                </Link>
                <nav>
                    <ul style={styles.nav}>
                        <li style={styles.navItem}>
                            <Link onClick={homeClickHandler} style={styles.navLink} to="/home">
                                {t('navigation.home')}
                            </Link>
                        </li>
                        <li style={styles.navItem}>
                            <Link onClick={ClickHandler} style={styles.navLink} to="/destination">
                                {t('navigation.destinations')}
                            </Link>
                        </li>
                        <li style={styles.navItem}>
                            <Link onClick={ClickHandler} style={styles.navLink} to="/contact">
                                {t('navigation.contact')}
                            </Link>
                        </li>
                        <li style={styles.navItem}>
                            <Link onClick={ClickHandler} style={styles.navLink} to="/bookings">
                                {t('navigation.bookings')}
                            </Link>
                        </li>
                    </ul>
                </nav>
                {/* ✅ Language Selector มุมขวาสุดของจอใหญ่ */}
                <div style={styles.languageBarDesktop}>
                    <LanguageSelector />
                </div>
            </div>

            {/* ✅ Bottom Navigation สำหรับมือถือ (เต็มจอ + เงาสวยขึ้น) */}
            <div style={styles.bottomNav} className="d-lg-none">
                <Link onClick={ClickHandler} to="/bookings" style={styles.navButton}>
                    <AiOutlineSearch style={styles.icon} />
                    <span>{t('navigation.bookings')}</span>
                </Link>
                <Link onClick={homeClickHandler} to="/home" style={{ ...styles.navButton, ...styles.activeButton }}>
                    <AiOutlineHome style={styles.icon} />
                    <span>{t('navigation.home')}</span>
                </Link>
                <Link onClick={ClickHandler} to="/contact" style={styles.navButton}>
                    <AiOutlineUser style={styles.icon} />
                    <span>{t('navigation.contact')}</span>
                </Link>
            </div>
        </>
    );
};

export default Header;